<template>
  <v-card outlined class="pa-4 mb-6">
    <h2 class="mdn-Heading mdn-Heading--xs mb-4">Configuração</h2>

    <SGPAlertaComponent v-if="erro">{{ erro }}</SGPAlertaComponent>

    <template v-else-if="configuracaoIntegracao">
      <div class="integracao-switches" :key="toggleKey">
        <SGPFormToggleComponent
          name="integracao_ativa"
          titulo="Integração geral"
          :value="Boolean(configuracaoIntegracao.integracao_ativa)"
          :readOnly="loadingConfiguracao"
          @input="solicitarAlteracao('integracao_ativa', $event)"
        />

        <SGPFormToggleComponent
          name="abrir_telmex"
          titulo="Abrir tickets Telmex"
          :value="Boolean(configuracaoIntegracao.abrir_telmex)"
          :readOnly="loadingConfiguracao || !configuracaoIntegracao.integracao_ativa"
          @input="solicitarAlteracao('abrir_telmex', $event)"
        />

        <SGPFormToggleComponent
          name="abrir_claro_geral"
          titulo="Abrir tickets Claro Geral"
          :value="Boolean(configuracaoIntegracao.abrir_claro_geral)"
          :readOnly="loadingConfiguracao || !configuracaoIntegracao.integracao_ativa"
          @input="solicitarAlteracao('abrir_claro_geral', $event)"
        />
      </div>

      <p v-if="!configuracaoIntegracao.integracao_ativa" class="grey--text mt-2 mb-0">
        Com a integração geral desligada, todos os tickets recebidos são ignorados.
      </p>

      <p class="grey--text mt-2 mb-0">
        Última atualização em {{ ultimaAtualizacao }}
      </p>
    </template>

    <SGPConfirmacaoComponent
      :mostrarModal="confirmacao.aberta"
      titulo="Confirmar alteração"
      :mensagem="confirmacao.mensagem"
      txtConfirmar="Sim, continuar"
      txtCancelar="Cancelar"
      @sgpConfirmarEmit="confirmarAlteracao"
      @sgpCancelarEmit="cancelarAlteracao"
    />

    <SGPLoadingComponent v-if="loadingConfiguracao" />
  </v-card>
</template>

<script>
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'

const ROTULOS_CAMPOS = {
  integracao_ativa: 'a integração geral',
  abrir_telmex: 'a abertura de tickets Telmex',
  abrir_claro_geral: 'a abertura de tickets Claro Geral',
}

const extrairErro = (error) => error?.response?.data?.message?.errors?.[0]
  || 'Não foi possível concluir a operação.'

export default {
  name: 'IntegracaoConfiguracaoComponent',

  data() {
    return {
      erro: null,
      toggleKey: 0,
      confirmacao: {
        aberta: false,
        mensagem: '',
        campo: null,
        valor: null,
      },
    }
  },

  async created() {
    try {
      await this.buscarConfiguracaoIntegracao()
    } catch (error) {
      this.erro = extrairErro(error)
    }
  },

  computed: {
    ...mapGetters('pcoWorkflowTemp', ['configuracaoIntegracao', 'loadingConfiguracao']),

    ultimaAtualizacao() {
      const data = this.configuracaoIntegracao?.updated_at
      return data && moment(data).isValid() ? moment(data).format('DD/MM/YYYY HH:mm') : '—'
    },
  },

  methods: {
    ...mapActions('pcoWorkflowTemp', [
      'buscarConfiguracaoIntegracao',
      'atualizarConfiguracaoIntegracao',
    ]),

    montarMensagem(campo, valor) {
      if (valor) {
        return `Deseja ligar ${ROTULOS_CAMPOS[campo]}? Os tickets recebidos a partir de agora voltarão a ser processados.`
      }

      return `Você está desligando ${ROTULOS_CAMPOS[campo]}. Enquanto desligado, os tickets recebidos serão descartados e NÃO serão abertos depois, mesmo que a integração seja religada. Deseja continuar?`
    },

    solicitarAlteracao(campo, valor) {
      const novoValor = Boolean(valor)

      if (novoValor === Boolean(this.configuracaoIntegracao?.[campo])) {
        return
      }

      this.confirmacao = {
        aberta: true,
        mensagem: this.montarMensagem(campo, novoValor),
        campo,
        valor: novoValor,
      }
    },

    cancelarAlteracao() {
      this.confirmacao.aberta = false
      this.toggleKey++
    },

    async confirmarAlteracao() {
      const { campo, valor } = this.confirmacao
      this.confirmacao.aberta = false

      try {
        await this.atualizarConfiguracaoIntegracao({ [campo]: valor })
      } catch (error) {
        // o interceptor do HttpClient já exibe message.errors em toast
      } finally {
        this.toggleKey++
      }
    },
  },
}
</script>

<style scoped>
.integracao-switches {
  display: flex;
  flex-wrap: wrap;
  gap: 32px;
}
</style>
